import { render, staticRenderFns } from "./ImageHeight.vue?vue&type=template&id=2a7bc44e&"
import script from "./ImageHeight.vue?vue&type=script&lang=js&"
export * from "./ImageHeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports